// extracted by mini-css-extract-plugin
export var imageHolder = "trainer-module--image-holder--6b2a5";
export var name = "trainer-module--name--44625";
export var nameHolder = "trainer-module--name-holder--2e3e8";
export var title = "trainer-module--title--53c0a";
export var titleHolder = "trainer-module--title-holder--f6c50";
export var wrapper = "trainer-module--wrapper--4f320";